import { I18n } from '@calendly/i18n'

import { triggerTitleText } from 'features/workflows'
import { getActionTitle, getVisibleActions } from 'services/workflows/actions'

const getPrimaryActionTitle = (workflow) => {
  const [action] = getVisibleActions(workflow.workflow_rule?.workflow_actions ?? [])
  if (!action?.configuration) return null

  return getActionTitle(action.configuration)
}

export const getAutomationMenuSubtitle = (workflow, isRebrandEnabled = false) => {
  const timing = triggerTitleText(workflow.type, workflow.workflow_rule, isRebrandEnabled)
  const actions = getVisibleActions(workflow.workflow_rule?.workflow_actions ?? [])

  if (actions.length === 1) {
    const actionTitle = getPrimaryActionTitle(workflow)

    if (actionTitle) {
      return I18n.t(
        'publisher.event_type_editor.sections.more_options.notifications.card_copy.automation_menu_single_action',
        { action: actionTitle, timing }
      )
    }
  }

  return I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.automation_multiple_actions',
    { timing }
  )
}
